<template>
    <div >
        <!--限时活动具体内容-->
        <calanderContent :selectActivity.sync="selectActivity" @clear="clear"></calanderContent>
        <div class="mask" v-show="selectActivity" @click="clear"></div>
        <div class="mobile">
            <div class="topBg">  
                <div class="my-container" :class="{zIndex:zIndex}">
                    <!--顶部logo、搜索、在线客服-->
                    <top></top>
                    <!--大奖线路-->
                </div> 
            </div>
            <div class="bg">
                <imgsLeftRight :bg="bg" :selectIndex="selectIndex" :timer="timer"></imgsLeftRight>
            </div>
        </div>  
        <div class="lineBox"> 
            <div class="innerBox">
                    <lines :line="line"></lines>
            </div> 
        </div>

                
            <!--日历-->
            <!-- <div class="calander">                   
                <div><img src="../assets/images/clock.png" />{{month}}月限时活动</div>
                <div>
                    <ul class="week">
                        <li>Mon</li>
                        <li>Tue</li>
                        <li>Wed</li>
                        <li>Thu</li>
                        <li>Fri</li>
                        <li>Sat</li>
                        <li>Sun</li>
                    </ul>
                </div>
                <div class="num35">
                    <ul class="tag">
                        <li v-for="i in getMonthMax" :key="i">
                            <div v-if="months[month-1][0]>=i  || ((months[month-1][0]+months[month-1][1])<i)">
                                <span>&nbsp;</span>
                            </div>
                            <div @click="showLimitActivity(i-months[month-1][0])" v-else>
                                <div v-if="showColor(0,i)" :class="{red:showColor(0,i)}"></div>
                                <div v-if="showColor(1,i)" :class="{blue:showColor(1,i)}"></div>
                                <div v-if="showColor(2,i)" :class="{brown:showColor(2,i)}"></div>
                                <div v-if="showColor(3,i)" :class="{purple:showColor(3,i)}"></div>
                                <div v-if="showColor(4,i)" :class="{green:showColor(4,i)}"></div>
                                <span>{{i-months[month-1][0]}}</span>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="detail">
                    <ul @click="showLimitActivityByType(index)" class="tag" v-for="(item,index) in activity" :key="index" :class="{                            
                            ul1:activity.length==1?true:false,
                            ul2:activity.length==2?true:false,
                            ul3:activity.length==3?true:false,
                            ul4:activity.length==4?true:false,
                            ul5:activity.length==5?true:false
                        }">
                        <li>
                            <div :class="{
                                    red:index==0,
                                    blue:index==1,
                                    brown:index==2,
                                    purple:index==3,
                                    green:index==4
                                }">&nbsp;</div>
                        </li> {{item.h4}}
                    </ul>
                </div>
            </div> -->
            <!-- 左侧Icon -->
            <ul class="platForm">
            <li>
                <div>
                    <p>苹果APP下载</p>
                    <img :src="makeQRCode('https://www.6040vip.com:8091/iosvip/index.html')" alt="">
                    <!-- <img :src="makeQRCode('https://djgame8.com/iosvip/')" alt=""> -->
                </div>
            </li>
            <li>
                <div>
                    <p>安卓APP下载</p>
                    <img :src="makeQRCode('https://www.6040vip.com:8091/android/DJVIP.apk')" alt="">
                    <!-- <img :src="makeQRCode('https://djgame8.com/app/DJVIP.apk')" alt=""> -->
                </div>
            </li>
                <li>
                    <div>
                        <p>大奖客诉部</p>
                        <img src="../assets/images/face-qr.png" alt="">
                        <p>
                            扫一扫或加<br>QQ:3542775763
                        </p>
                    </div>
                </li>
                <li>
                    <a href="https://v60.livechatvalue.com/chat/chatClient/chatbox.jsp?companyID=80000805&configID=402&codeType=custom&enterurl=pt8.me" target="_blank"></a>
                </li>
            </ul>
            <ul class="platForm wap">
                <li >
                        <a target="_blank" href="https://djgame8.com/iosvip/"></a>
                </li>
                <li >
                        <a target="_blank" href="https://djgame8.com/app/DJVIP.apk"></a>
                </li>
                <li @click="indexVal=true" >
                        <img v-if="indexVal" src="../assets/images/face-qr.png" alt="">
                </li>
                <li>
                    <a href="https://v60.livechatvalue.com/chat/chatClient/chatbox.jsp?companyID=80000805&configID=402&codeType=custom&enterurl=pt8.me" target="_blank"></a>
                </li>
            </ul>
            <!-- banner下方6个Act -->
            <!--活动图片预加载-->
            <imgs style="display:none;" v-for="item in activity" :key="item.img" :src="item.img"/>
    </div>
</template>

<script>
import top from './a.header.top.vue'
import lines from './a.header.line.vue'
import calander from './a.header.calander.vue'
import imgs from './a.header.img.vue'
import imgsLeftRight from './a.header.img.leftright.vue'
import calanderContent from './a.header.calander.content.vue'
import axios from '../axios'
import QRCode from "qrcode";

export default {
    components: {
        lines, top, calander, imgsLeftRight, imgs, calanderContent
    },
    data() {
        return {
            bg: [],
            line:[],
            selectIndex: 0,
            month: new Date().getMonth() + 1,
            banner: [],
            timer: null,
            months: [
                [0, 31],
                [3, 28],
                [3, 31],
                [5, 30],
                [1, 31],
                [4, 30],
                [4, 31],
                [4, 30],
                [4, 30],
                [6, 31],
                [2, 30],
                [4, 31]
            ],
            activity: [],
            selectActivity:null,
            zIndex:false,
            indexVal:false,
        }
    },
    computed:{
        getMonthMax(){
            return (this.months[this.month-1][0] + this.months[this.month-1][1]) > 35 ? 42 : 35;
        }
    },
    created() {
        var that = this;

        axios.getLines(function(data){
            that.line = data.data.line;
        })

        axios.getBanner(function(data) {

            that.banner = data.data.banner;
            that.bg = []
            data.data.bg.forEach(function(e) {
                that.bg.push(/^http:\/\/|^https:\/\//i.test(e) ? e : require('../assets/images/' + e));
            })
            that.timeInterval();
        })

        axios.getActivity(function(data) {
            that.activity = data.data.activity;
            that.activity = that.activity.map(function(e) {
                e.img = /^http:\/\/|^https:\/\//i.test(e.img) ? e.img : require('../assets/images/' + e.img)
                //dateCommand
                if(e.dateCommand){
                    //每周一
                    if(e.dateCommand == "everyMonday"){
                        e.date = [];
                        let currentDate = new Date();
                        for(let day=1;day<=31;day++){
                            let week = new Date(currentDate.getFullYear()+'/'+that.month+'/'+day).getDay();
                            if(week==1){
                                e.date.push(day)
                            }
                        }
                    }
                }
                return e;
            })
        })
    },
    methods: {
        makeQRCode(link="") {
                // margin :二维码安静区域宽度，值越小白边越小，默认4
                let ret = ''
                let segs = {
                    margin: "1",
                    errorCorrectionLevel: "H"
                }

                if(link){
                    QRCode.toDataURL(link, segs, function (err, url) {
                        ret = url;
                    });
                }
                return ret;
        },
        clear(){
            document.body.style.overflow = 'inherit' ;
            this.selectActivity=null
        },
        showColor(index,i){
            return this.activity.length>index && this.activity[index].date.indexOf(i-this.months[this.month-1][0])>-1;
        },
        tagClick(index) {
            // console.log(1)
            // this.selectIndex = index
            // this.timeInterval()
        },
        timeInterval() {
            if (this.timer) {
                clearInterval(this.timer)
                this.timer = null;
                //this.timeInterval();
            }
            else {
                this.timer = setInterval(() => {
                    this.selectIndex = ++this.selectIndex % 5;
                }, 5000)
            }
        },
        tagMouseOver(index) {
            this.selectIndex = index
            clearInterval(this.timer)
            this.timer = null;
            this.zIndex = true;
        },
        tagMouseOut(index) {
            this.selectIndex = index
            this.timeInterval()
            this.zIndex = false;
        },
        showLimitActivity(index){
            console.log(index)
            let arr = [],that = this;
            this.activity.forEach(function(e,ei) {
                if(e.date instanceof Array){
                    e.date.forEach(function(m){
                        if(index === m){
                            arr.push(ei)
                        }
                    })
                }
            })
            if(arr.length>0){            
                document.body.style.overflow = "hidden"
                document.body.scrollTop = 0;
                this.selectActivity = arr.map(function(e,ei){
                    return that.activity[e];
                });
            }
        },
        showLimitActivityByType(index){
            document.body.style.overflow = "hidden"
            document.body.scrollTop = 0;
            this.selectActivity = [].concat(this.activity[index]);
        }
    }
}
</script>
<style scoped>
.bg {
    height: 698px;
    /* padding-bottom: 36.3%; */
    /* background-size:100% 100%; */
    background-repeat: no-repeat;
    position: relative;
    border: 2px solid #bda54b;
    border-left:0;
    border-right: 0;
}
.topBg{
    background: #2b1f2e url(../assets/images/topBg.jpg) no-repeat top center;
    height: 200px;
    
}

.bg-black {
    position: absolute;
    background: rgba(67, 67, 67, 1);
    height: 76px;
    width: 100%;
}

.bgi {
    width: 100%;
    height: 680px;
    position: absolute;
    top: 0;
}
.lineBox{
    margin-top: 10px;
    position: absolute;
    width: 100%;
    top: 152px;
    left: 0px;

}
.lineBox .innerBox{
    width: 1370px;
    margin: 0 auto;
}
.mask{
    position: fixed;
    background: rgba(0,0,0,0.8);
    top:0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
}

.my-container {
    margin: 0 auto;
    position: relative;
    height: 100%;
    overflow: hidden;
}

.bg1 {
    background-image: url(../assets/images/bg1.jpg)
}

.bg2 {
    background-image: url(../assets/images/bg2.jpg)
}

.bg3 {
    background-image: url(../assets/images/bg3.jpg)
}

.row {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 96px;
}



.col-xs-12,
.col-xs-6,
.col-xs-4,
.col-xs-3 {
    padding: 0px;
}

.mrgin10 {
    color: #fff;
    background: rgba(0, 0, 0, 0.6);
    cursor: pointer;
    height: 96px;
    transition: all .5s linear;
    border-radius: 10px 10px 0 0;
}

.mrgin10 .h6{    
    padding: 0 10px 10px 10px;
    font-size: 14px;
    line-height: 25px;
    font-size: 14px!important;
    letter-spacing:1px;
    margin-top: 5px;
}

.col-xs-4:nth-child(2) .mrgin10 {
    margin: 0 10px;
}
.row>div[class*=col]{
    padding: 0 5px;
}
.platForm{
    display: block;
}
.platForm.wap{
    display: none
}

@media screen and (max-width:768px){
    .row>div[class*=col]{
        padding: 0 15px;
        display: none;
    }
    .row>div[class*=active]{
        display: block;
    }
.lineBox .innerBox{
   width: 100%;
}
    .zIndex{
        z-index: 999;
    }
    .calander{
        display: none;
    }
     .topBg{
        height: 120px;
        overflow: hidden;
    }
    .lineBox{
        margin-top: 10px;
        position: absolute;
        width: 104%;
        top: 78px;
        left: -15px;

    }
    .topBg img{
        display: block;
        height: 100%;
    }
    .logo3{
        height: 45px;
    }
    .a-top div.line ul{
            width: 102%;
        }
    .platForm{
        display: none;
    }
    .platForm.wap{
        display: block;
        position: inherit;
        overflow: hidden;
        width: 100%;
        height: auto;
        background: #080703;
       
    }
    .platForm.wap li{
        width: 25%;
        height: 80px;
        float: left;
        margin:10px 0;
        background-size:100% 100%; 
        position: relative;
    }
    .platForm.wap li img{
        position: absolute;
        top:2px;
        left: 8px;
        width: 75px;
        height: 75px;
    }
    .platForm.wap li:hover{
        background-size:100% 100%; 
    }
    
}
.active .mrgin10 {
    background: rgb(140, 137, 102)
}

.mrgin10 a {
    float: right;
    margin: 3px 10px 0 0;
    color: #fff;
}


.mrgin10:hover {
    height: 500px;
}

.hoverx0:hover{
    transform: translateY(-210px);
}
.hoverx1:hover{
    transform: translateY(-210px);
}
.hoverx2:hover{
    transform: translateY(-290px);
} 

.calander {
    width: 310px;
    /* min-height: 390px; */
    float: right;
    text-align: left;
    background: #474747;
    color: #fff;
    text-align: center;
    overflow: hidden;
    position: absolute;
    right: 265px;
    top: 330px;
    /* box-shadow: 2px 2px 2px 2px #000; */
}
.platForm{
    width: 152px;
    text-align: left;
    color: #fff;
    text-align: center;
    position: absolute;
    left: 0px;
    top: 260px;
    height: 600px; 
}
.platForm li{
    height: 130px;
    width: 150px;
    margin-bottom: 12px;
}
.platForm li a{
    display: block;
    height: 100%;
    width: 100%;
}
.platForm li{
position: relative;
cursor: pointer;
}
.platForm li div{
    width: 100px;
    height: 100px;
    position: absolute;
    right: -115px;
    top: -10px;
    opacity: 0;
    transition: 0.7s;
}
.platForm li:hover div{
    opacity: 1;
}
.platForm li div p{
    line-height: 16px;
    font-size: 14px;
}
.platForm li div img{
    width: 100px;
    height: 100px;
    padding-bottom: 8px;
}
.platForm li:nth-child(1){
     background: url(../assets/images/iosIcon.png) no-repeat center top;
     transition:all  0.5s;
     background-size: 100%;
}
.platForm li:nth-child(1):hover{
     background: url(../assets/images/iosIcon_cur.png) no-repeat center top;
     background-size:100% 100%; 
}
.platForm li:nth-child(2){
     background: url(../assets/images/andrioIos.png) no-repeat center top;
     background-size: 100%;
}
.platForm li:nth-child(2):hover{
     background: url(../assets/images/andrioIos_cur.png) no-repeat center top;
     background-size: 100%;
}
.platForm li:nth-child(3){
     background: url(../assets/images/recomend.png)  no-repeat center top;
     transition:all  0.5s;
     background-size: 100%;
}
.platForm li:nth-child(3):hover{
     background: url(../assets/images/recomend_cur.png)  no-repeat center top;
     background-size:100% 100%; 
}
.platForm li:nth-child(4){
     background: url(../assets/images/onlineServer.png) no-repeat center top;
     transition:all  0.5s;
     background-size: 100%;
}
.platForm li:nth-child(4):hover{
     background: url(../assets/images/onlineServer_cur.png) no-repeat center top;
     background-size:100% 100%; 
}

.calander img:first-child {
    margin-top: -9px;
    padding-right: 10px;
}

.calander>div:first-child {
    font-size: 25px;
    font-family: "RTWSYueRoudGoDemo";
    color: rgb( 206, 196, 152);
    line-height: 1.083;
    text-align: center;
    padding: 20px 0 20px 0;
}

ul {
    margin: 0;
    padding: 0;
}

li {
    list-style-type: none;
    display: inline-block;
    width: 40px;
    height: 40px;
}

.week {
    background:#525252;
}

.week li {
    line-height: 40px;
}

.tag li,
.detail li {
    line-height: 30px;
}

li>div {
    margin: 5px;
}

.tag li {
    text-align: center;
    display: inline-block;
    border-bottom: 1px solid #565656;
}

li>div,
li>div::after {
    border-radius: 30px;
    position: relative;
}

li>div>span {
    position: relative;
    /* margin: 0 0 0 -3px; */
}

.detail li>div {
    position: inherit;
}


.red,
.blue,
.brown,
.purple,
.green {
    position: absolute;
    height: 30px;
    width: 30px;
    border-radius: 30px;
}

.red {
    background: rgba(249, 107, 107, 0.8);
}

.blue {
    background: rgba(89, 149, 216, 0.8);
}

.brown {
    background: rgba(140, 137, 102, 0.8);
    /* background: rgba(0, 0, 0, 0.8); */
}

.purple {
    background: rgba(152, 10, 199, 0.8);
}

.green {
    background: rgba(57, 226, 37, 0.8);
}

li>div>div:nth-child(2) {
    width: 25px;
    height: 25px;
    margin: 3px;
}

li>div>div:nth-child(3) {
    width: 18px;
    height: 18px;
    margin: 6px;
}

li>div>div:nth-child(4) {
    width: 14px;
    height: 14px;
}




/* .red.blue::after {
    content: '';
    width: 60%;
    height: 60%;
    display: inline-block;
    background: rgba(249, 107, 107, 0.8);
    position: absolute;
    top: 0;
    left: 0;
    margin: 9px;
} */

.detail{
        text-align: left;
    margin-left: 30px;
}

.detail ul {
    display: inline-block;
    width: 48%;
    margin-top: 30px;
    margin-left: -10px;
}

.detail ul li {
    border: none;
}

.flash {
    cursor: pointer;
    position: absolute;
    left: -230px;
    top: 0;
    width: 230px;
    height: 100%;
    background-image: -moz-linear-gradient(0deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0));
    background-image: -webkit-linear-gradient(0deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0));
    transform: skewx(-25deg);
    -o-transform: skewx(-25deg);
    -moz-transform: skewx(-25deg);
    -webkit-transform: skewx(-25deg);
    -ms-transform: skewx(-25deg);
    animation: changeFlash 30s ease-out 0s infinite;
    -ms-animation: changeFlash 30s ease-out 0s infinite;
    -moz-animation: changeFlash 30s ease-out 0s infinite;
    -webkit-animation: changeFlash 30s ease-out 0s infinite;
    -o-animation: changeFlash 30s ease-out 0s infinite;
}

@keyframes changeFlash{
    0%{
        left: -230px;
    }
    10%{
        left: -230px;
    }
    15%{        
        left: 100%;
        -moz-transition: 1.5s;
        -o-transition: 1.5s;
        -webkit-transition: 1.5s;
        -ms-transition: 1.5s;
        transition: 1.5s;
    }
    100%{        
        left: 100%;
        -moz-transition: 1.5s;
        -o-transition: 1.5s;
        -webkit-transition: 1.5s;
        -ms-transition: 1.5s;
        transition: 1.5s;
    }
  }



.num35 li>div {
    transition: all .5s linear;
    cursor: pointer;
}

.num35 li>div:hover {
    transform: scale(1.3, 1.3)
}

.detail{
    padding:10px 0 4px 0;
}

.detail ul[class*=ul] div{
    height: 20px;
    width: 20px;
    line-height: 20px;
}
.detail ul[class*=ul] li{
    height: 30px;
}

.detail ul.ul3,.detail ul.ul4{
    margin-top: 0px;    
    cursor: pointer;
}

.row-close{
    position: absolute;
    color: #fff;
    right: 30px;
    top:10px;
    font-size: 15px;
    display: inline-block;
    background: rgba(255,255,255,0.3);
    height: 22px;
    width: 22px;
    text-align: center;
    border-radius: 11px;
}
</style>

<style>

.mrgin10 .h6 h4,.mrgin10 .h6 span {
    color:#ffd241;
}

.mrgin10 h4{
    font-weight: bold;

        /* background: black;
    padding: 0;
    margin: 0;
    height: 30px;
    line-height: 30px; */

    
}

h4[class^=h4]{
    margin: 0;
    line-height: 40px;
    height: 40px;
    padding-left: 10px;
    background: rgba(0,0,0,0.5);
    border-radius:10px 10px 0 0 ;
    color:#ffd241;
}

</style>




// WEBPACK FOOTER //
// src/components/a.header.vue